import axios from '@/utils/api'

const actions = {
  async downloadDocumento ({commit}, id) {
    await axios({
      method: 'get',
      url: `documento/publico/downloadDocumentoById/${id}`,
      responseType: 'blob'
    })
  },
  async getDadosDocumento ({ commit }, payload) {
    const response = await axios({
      method: 'get',
      url: `documento/publico/buscarDadosGerais/${payload.tipoDocumento}/${payload.idProcesso}`
    })
    return response
  },

  async deleteDocumentoById ({ commit }, idDocumento) {
    await axios({
      method: 'DELETE',
      url: `documento/deleteById/${idDocumento}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/documentos.js